module.exports = __webpack_public_path__ + "site/img/48.832dece0.jpg";